import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import classes from './DataTable.module.css';

const DenseTable = (props) => {
  return (
    <TableContainer component={Paper}>
      <Table className={classes.Table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell align="center">{props.tableData.xTitle}</TableCell>
            <TableCell align="center">{props.tableData.yTitle}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {props.tableData.data.map((row,index) => (
          <TableRow key={index}>
            <TableCell align="center">{row[props.tableData.xKey]}</TableCell>
            <TableCell align="center">{row.value}</TableCell>
          </TableRow>
        ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default DenseTable;